/**
 * CoPilot Brain (journey-web) — the CITIZEN Companion.
 *
 * Thin portal wrapper. The conversation UI itself lives in the shared
 * `@tonnie/copilot-ui` package, which business-web renders too — so the two
 * portals can never drift apart. Everything below is what makes this instance
 * the *citizen* one: the hero brand decorator, the Care route a critical safety
 * banner's help links to, the proactive corner-cue, and the citizen
 * file-actions that consume an attachment.
 */

import { type ICoPilotBrainProps } from '@tonnie/copilot-core';
import { CoPilotConversation, decorateBrand, ProactiveCue } from '@tonnie/copilot-ui';

import { useCoPilotSidebar } from '@/core/contexts/CoPilotSidebarContext';
import { useCoPilotEngine } from '@/features/platform/copilot/context/CoPilotEngineProvider';

export function CoPilotBrain({ suggestions = [] }: ICoPilotBrainProps) {
  const { isOpen } = useCoPilotSidebar();
  // The engine is hoisted to the app root (0089) so it survives navigation —
  // this component is now a thin view over it.
  const brain = useCoPilotEngine();

  return (
    <CoPilotConversation
      {...brain}
      suggestions={suggestions}
      decorateStrong={decorateBrand}
      billingHref="/billing"
      careHref="/care"
      proactiveSlot={<ProactiveCue enabled={isOpen} />}
    />
  );
}
